"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormNumberInput = void 0;
const merlin_button_icon_1 = require("@travelnest/merlin.button-icon");
const React = __importStar(require("react"));
const FormNumberInput = (_a) => {
    var props = __rest(_a, []);
    const change = (increment) => {
        const next = parseInt((props.value || 0).toString(), 10) + increment;
        if (props.onChange)
            props.onChange({ target: { value: next } });
    };
    const value = parseInt((props.value || 0).toString(), 10);
    const min = typeof props.min === 'undefined' ? -Infinity : parseInt(props.min.toString(), 10);
    const max = typeof props.max === 'undefined' ? Infinity : parseInt(props.max.toString(), 10);
    const minDisabled = (props.disabled || value <= min);
    const maxDisabled = (props.disabled || value >= max);
    const incrementValue = props.increment || 1;
    const formInputSize = `form__input--size-${props.widthtype || 'default'}`;
    const classList = ['form__input', 'form__input--number', formInputSize];
    if (props['is-valid'] === 'false' || props['is-valid'] === false) {
        classList.push('form__input--error');
    }
    return (React.createElement("div", { className: "form-number-input" },
        React.createElement("input", Object.assign({ className: classList.join(' ') }, props)),
        React.createElement(merlin_button_icon_1.IconButton, { disabled: minDisabled, icon: "minus", onClick: (e) => { if (!minDisabled)
                change(-incrementValue); e.preventDefault(); } }),
        React.createElement(merlin_button_icon_1.IconButton, { disabled: maxDisabled, icon: "plus", onClick: (e) => { if (!maxDisabled)
                change(incrementValue); e.preventDefault(); } })));
};
exports.FormNumberInput = FormNumberInput;
//# sourceMappingURL=FormNumberInput.js.map